import { getDomainErrorMessage } from '@/lib/utils/domain-error-translator';
import type { TFunction } from 'i18next';

export interface DataSourceErrorItem {
  code?: string | null;
  message?: string | null;
}

const DEFAULT_MESSAGE_KEY = 'general.error_import';

export function getDataSourceErrorMessage(
  errors: DataSourceErrorItem[],
  t: TFunction,
  defaultMessageKey: string = DEFAULT_MESSAGE_KEY
): string {
  if (errors.length === 0) {
    return t(defaultMessageKey);
  }

  if (errors.length === 1) {
    const error = errors[0];
    return error.code
      ? getDomainErrorMessage(error.code, t, defaultMessageKey)
      : error.message || t(defaultMessageKey);
  }

  return errors
    .map((error, index) => {
      const msg = error.message || '';
      const codePart = error.code
        ? ` (${t('general.code')}: ${error.code})`
        : '';
      return `${index + 1}. ${msg}${codePart}`;
    })
    .join('\n\n');
}

export interface ShowDataSourceErrorToastParams {
  errors: DataSourceErrorItem[];
  t: TFunction;
  toast: (opts: {
    title: string;
    description: string;
    variant: 'destructive';
  }) => void;
  titleKey?: string;
  defaultMessageKey?: string;
}

export function showDataSourceErrorToast({
  errors,
  t,
  toast,
  titleKey = DEFAULT_MESSAGE_KEY,
  defaultMessageKey = DEFAULT_MESSAGE_KEY,
}: ShowDataSourceErrorToastParams): void {
  const description = getDataSourceErrorMessage(errors, t, defaultMessageKey);
  toast({
    title: t(titleKey),
    description,
    variant: 'destructive',
  });
}
